import React from "react";
import { Card, Icon } from "semantic-ui-react";
import "./ReportCard.scss";

export function ReportCard(props) {
  const { title, icon, onClick } = props;

  return (
    <Card className="report-card" onClick={onClick}>
      <Card.Content className="report-card__content">
        <div className="report-card__icon">
          <Icon name={icon} size="huge" />
        </div>
        <div className="report-card__title">{title}</div>
      </Card.Content>
    </Card>
  );
}